import React, { useState } from 'react'
import Slider from 'react-slick';
import Carousel, { Modal, ModalGateway } from 'react-images';
import CustomModal from './CustomModal'
import Image from './Image'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const ImageSlider = ({ images, sliderClass, video, toggleImagesModal, imagesModal, floorplan, sliderText }) => {
  const CarouselImageLabel = (carouselProps) => <div className="carousel-image-label">{images[carouselProps.currentIndex].label}</div>;
  const MultiVideoView = (carouselProps) => {
    return <iframe className="multi-video-slider" src={`https://www.youtube.com/embed/${carouselProps.currentView}`} autoPlay frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
  };
  const modalImages = images.map((image) => ({ src: image.image }));
  const modalFloorplan = floorplan.map((image) => ({ src: image.image }));

  const [isVideoModalOpen, setVideoModalStatus] = useState(false);
  const toggleVideoModal = () => {
    if (isVideoModalOpen) {
      return setVideoModalStatus(false);
    }
    return setVideoModalStatus(true);
  }

  const [isFloorplanModalOpen, setFloorplanModalStatus] = useState(false);
  const toggleFloorplanModal = () => {
    if (isFloorplanModalOpen) {
      return setFloorplanModalStatus(false);
    }
    return setFloorplanModalStatus(true);
  }


  const renderFloorplan = () => {
    if (!floorplan || floorplan === "") {
      return null;
    }
    return (
      <ModalGateway>
        {isFloorplanModalOpen ? (
          <Modal onClose={toggleFloorplanModal} closeOnBackdropClick>
            <Carousel styles={{ view: () => ({ maxWidth: '80vw', margin: '0 auto' }) }} currentIndex={imagesModal.index} views={modalFloorplan} />
          </Modal>
        ) : null}
      </ModalGateway>
    );
  }

  const renderVideos = () => {
    if (!video) {
      return null;
    }
    if (video.indexOf(",") > -1) {
      const videoArray = video.split(", ");
      return (
        <ModalGateway>
          {isVideoModalOpen ? (
            <Modal onClose={toggleVideoModal} closeOnBackdropClick>
              <Carousel styles={{ view: () => ({ textAlign: 'center' }) }} currentIndex={imagesModal.index} views={videoArray} components={{ View: MultiVideoView }} />
            </Modal>
          ) : null}
        </ModalGateway>
      );
    }
    return (
      <CustomModal onClose={toggleVideoModal} isOpen={isVideoModalOpen}>
        <iframe className="youtube-embed" src={`https://www.youtube.com/embed/${video}`} autoPlay frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
      </CustomModal>
    );
  }
  const config = {
    dots: false,
    dotsClass: "slick-dots",
    infinite: true,
    arrows: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
          dots: false
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false
        }
      }
    ]
  };

  return (
    <div>
      <Slider {...config}>
        {
          images.map((image, index) => (
            <div className={sliderClass} onClick={() => toggleImagesModal(index)} key={`slider-image-${index}`}>
              <Image classes={"slider-image"} imageInfo={{ image: image.image }} />
              <div>{image.label}</div>
            </div>
          ))
        }
      </Slider>
      <ModalGateway>
        {imagesModal.isOpen ? (
          <Modal onClose={toggleImagesModal} closeOnBackdropClick>
            <Carousel styles={{ view: () => ({ '@media all and (min-width: 1500px)': { maxWidth: '50vw' }, maxWidth: '70vw', margin: '0 auto' }) }} currentIndex={imagesModal.index} views={modalImages} components={{ Footer: CarouselImageLabel }} />
          </Modal>
        ) : null}
      </ModalGateway>
      <div className="slider-buttons">
        <span className="slider-photos" onClick={() => toggleImagesModal()}>{sliderText.photo}</span>
        {!!floorplan && floorplan.length > 0 ? <span className="slider-floorplan" onClick={() => toggleFloorplanModal()}> | {sliderText.floorplan}</span> : null}
        {!!video ? <span className="slider-video" onClick={() => toggleVideoModal()}> | {sliderText.video}</span> : null}
      </div>
      {renderVideos()}
      {renderFloorplan()}
    </div>
  );
}

export default ImageSlider
